const ABProcessTaskUserApprovalCore = require("../../../core/process/tasks/ABProcessTaskUserApprovalCore");
module.exports = class ABProcessTaskUserApproval extends (
   ABProcessTaskUserApprovalCore
) {};
